import { useQuery } from '@tanstack/react-query';
import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';
import api from 'src/utils/ajax';

interface Product {
  id: string;
  name: string;
}

interface ProductFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
  multiple?: boolean;
}

export const ProductFilter: React.FC<ProductFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
  multiple,
}) => {
  const { data: products = [] } = useQuery({
    queryKey: ['products', 'pluck_columns'],

    queryFn: async () => {
      const response = await api.get('/api/v2/products', {
        params: {
          fetch_all: true,
          pluck_columns: 'id,name',
          'q[s]': 'name asc',
        },
      });
      return response.data;
    },
  });

  const valueIds = value ? String(value).split(',').map(Number) : [];
  const selectedProducts = products.filter((p) => valueIds.includes(p.id));

  if (valueOnly) {
    return <>{selectedProducts.map((p) => p.name).join(', ')}</>;
  }

  return (
    <Autocomplete
      multiple={multiple}
      options={products}
      getOptionLabel={(option: Product) => option.name}
      value={multiple ? selectedProducts : selectedProducts[0] || null}
      onChange={(_, newValue) => {
        if (multiple) {
          setValue(
            (Array.isArray(newValue) ? newValue : []).map((p) => p.id).join(',')
          );
        } else {
          setValue(newValue?.id || '');
        }
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Select Product" />
      )}
    />
  );
};
